// Match existing bar_exam ExamSubject / Exam codes; subject remains the title.
export const SUBJECT_OPTIONS = [
  ["public_law", "공법"], ["criminal_law", "형사법"], ["civil_law", "민사법"],
  ["constitutional", "헌법"], ["administrative", "행정법"],
  ["criminal", "형법"], ["criminal_procedure", "형사소송법"],
  ["civil", "민법"], ["civil_procedure", "민사소송법"], ["commercial", "상법"],
];
export const QUESTION_TYPE_OPTIONS = [["case", "사례형"], ["record", "기록형"]];
export const YEAR_OPTIONS = Array.from({ length: 15 }, (_, i) => [String(2012 + i), `${2012 + i}년`]);
export const EXAM_OPTIONS = [
  ["bar_mock_1", "1차 모의시험"], ["bar_mock_2", "2차 모의시험"],
  ["bar_mock_3", "3차 모의시험"], ["bar_actual", "변호사시험"],
];
export const ORDERING_OPTIONS = [
  ["-created_at", "최근 작성순"], ["created_at", "오래된 작성순"],
  ["title", "가나다순"], ["-title", "가나다 역순"],
  ["-modified_at", "최근 수정순"], ["duration_seconds", "작성시간 짧은순"],
  ["-duration_seconds", "작성시간 긴순"],
];
export const normalizeAnswerMetadata = (value = {}) => ({
  subject_code: value.subject_code || null,
  is_past_exam: Boolean(value.is_past_exam),
  question_type: value.is_past_exam ? value.question_type || null : null,
  exam_year: value.is_past_exam ? value.exam_year || null : null,
  exam_type: value.is_past_exam ? value.exam_type || null : null,
  exam_round: value.is_past_exam && value.exam_type === "bar_mock" ? value.exam_round || null : null,
});
export const getExamValue = (value) => value.exam_type === "bar_mock"
  ? (value.exam_round ? `bar_mock_${value.exam_round}` : "") : value.exam_type || "";
export const getPastExamLabel = (answer) => answer.is_past_exam ? [
  answer.exam_year ? `${answer.exam_year}년` : "",
  EXAM_OPTIONS.find(([value]) => value === getExamValue(answer))?.[1],
  QUESTION_TYPE_OPTIONS.find(([value]) => value === answer.question_type)?.[1],
].filter(Boolean).join(" · ") : "";
export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return "";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainder = seconds % 60;
  if (hours) return `${hours}시간 ${String(minutes).padStart(2, "0")}분${remainder ? ` ${String(remainder).padStart(2, "0")}초` : ""}`;
  if (minutes) return `${minutes}분 ${String(remainder).padStart(2, "0")}초`;
  return `${remainder}초`;
};
